<template>
  <div class="jobs-list" v-loading="loader">
    <el-form>
      <filter-select
        v-model="object"
        label="Выберите раздел"
        :options="list"
      />
    </el-form>
    <el-input placeholder="Поиск ..." v-model="search" class="input-search">
      <el-button slot="append" icon="el-icon-search"></el-button>
    </el-input>
    <div class="jobs-ul">
      <div class="jobs-li" v-for="(job, index) in filteredList" :key="index">
        <div class="jobs-text">
<!--          <a @click="downloadURI(job.file, job.name)">{{ job.name }}</a>-->
<!--          IOS ONLY -->
          <a :href="job.file" target="_blank">{{ job.name }}</a>
        </div>
        <span>
          <i class="fa fa-link" v-clipboard:copy="job.file" v-clipboard:success="onCopy"></i>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase';
import draggable from 'vuedraggable';
import _ from 'lodash';
import FilterSelect from '../../../components/FilterSelect';
import AddDoc from "../Reports/components/AddDoc";
import {getChildList} from "../../../utils/getChild";
import {downloadURI} from "../../../utils/urlUtils";
import {getPermissionDocs} from "../../../firestore/permission";
import {filterDocs, filterFiles} from "../../../utils/filterJobs";

export default {
  name: 'List',
  components: {AddDoc, FilterSelect, draggable},

  data() {
    return {
      loader: false,
      search: '',
      jobs: [],
      list: [],
      permission: [],
      object: null,
    }
  },
  async mounted() {
    this.permission = await getPermissionDocs(this.$store.state.project.id, this.$store.state.company.uid || firebase.auth().currentUser.uid);
    this.fetchJobs();
    this.fetchTree();
    this.getObject(this.$route.params.docs);
  },

  methods: {
    downloadURI,
    getObject(id) {
      const result = [];
      firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('documentation')
        .doc(id)
        .get()
        .then((subDoc) => {
          const data = subDoc.data();
          if (data) {
            result.push({
              id: subDoc.id,
              name: data.name || '',
              objects: data.objects,
              parentId: data.parentId || undefined,
              isParent: data.isParent,
            });
          }
        }).finally(() => {
        // const obj = getChildList(result);
        if (result && result[0]) {
          this.object = result[0];
        }
      })
    },
    onCopy() {
      this.$notify.success({
        offset: 60,
        title: 'Ссылка скопирована',
      });
    },
    updateJobs() {
      this.fetchJobs();
    },
    fetchTree() {
      this.loader = true;
      const result = [];
      firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('documentation')
        .get()
        .then((data) => {
          data.forEach((subDoc) => {
            const data = subDoc.data();
            result.push({
              id: subDoc.id,
              name: data.name,
              objects: data.objects,
              index: data.index,
              parentId: data.parentId || undefined,
              isParent: data.isParent,
            });
          });
        }).finally(() => {
        const r = _.orderBy(filterDocs(getChildList(result), this.permission), 'index', ['asc']);
        this.list = [
          {
            label: 'Показать все',
            value: null,
          },
          {
            label: 'Без раздела',
            value: 'all',
          },
          ...r.map((r) => {
            return {
              label: r.name,
              value: r.id,
            };
          })];
        this.loader = false;
      }).catch(() => {
        this.loader = false;
      });
    },
    edit(file) {
      this.loading = true;
      firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('files').doc(file.id)
        .update({
          name: file.name,
        }).then((add) => {
        this.$notify({
          offset: 60,
          title: 'Успешно!',
          message: 'Файл отредактирован',
          type: 'success',
        });
      }).catch((error) => {
        console.error(error);
        this.$notify({
          offset: 60,
          title: 'Упс... ',
          message: 'Произошла ошибка повторите позже',
          type: 'error',
        });
      }).finally(() => {
        this.loading = false;
      });
    },
    deleteObject(id) {
      this.$confirm('Вы действительно хотите удалить файл?', 'Подтверждение', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Нет',
        type: 'warning',
      }).then(() => {
        firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('files')
          .doc(id).delete()
          .then((data) => {
            this.$notify({
              offset: 60,
              title: 'Успешно!',
              message: 'удалено',
              type: 'success',
            });
            this.fetchJobs();
          });
      });
    },
    save: _.debounce(function (el, binding) {
      const jobs = this.jobs.map((job, index) => {
        return {
          ...job,
          _data: {
            job: job._data,
            index: index,
          },
        };
      });

      this.update(jobs);
    }, 1000),
    update(jobs) {
      let batch = firebase.firestore().batch();
      jobs.forEach((doc) => {
        const docRef = firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('files')
          .doc(doc.id);
        batch.update(docRef, doc._data);
      });
      batch.commit();
    },
    getUrl() {
      return `/dashboard/files/${this.$route.query.docs || this.$route.params.id || 'new'}/create/`;
    },
    fetchJobs() {
      this.loader = true;
      const result = [];
      let req = null;
      if (this.$route.params.id) {
        req = firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('files')
          .where(`documentation`, 'array-contains-any', [this.$route.params.id]);
      } else {
        req = firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('files')
      }
      req.get()
        .then((data) => {
          data.forEach((subDoc) => {
            const data = subDoc.data();
            result.push({
              id: subDoc.id,
              name: data.name,
              file: data.file,
              _data: data,
            });
          });
        })
        .finally(() => {
          this.jobs = _.orderBy(filterFiles(result, this.permission, this.$route.params.id || null), '_data.index', ['asc']);
          this.loader = false;
        });
    },
  },

  computed: {
    filteredList() {
      const jobs = this.jobs.filter((job) => {
        const search = job.name.toLowerCase().includes(this.search.toLowerCase());
        if (this.object && this.object.value) {
          if(!job._data.documentation) {
            job._data.documentation = []
          }
          return search && job._data.documentation.includes(this.object.value);
        }
        return search;
      });

      return filterFiles(jobs, this.permission, (this.object && this.object.value) || null);
    },
  },
};
</script>

<style scoped lang="scss">
.jobs-list {
  max-width: 428px;
  width: calc(100% - 40px);
  margin: 22px auto;
  padding-top: 20px;
}

.jobs-text {
  display: flex;
  align-items: center;
  overflow: hidden;
  max-width: 80%;
  text-overflow: ellipsis;

  a {
    color: #000;
    text-decoration: none;
    overflow: hidden;
    text-overflow: ellipsis;

    &:hover {
      text-decoration: underline;
    }
  }

  .handle {
    margin-right: 30px;
  }
}

.input-search {
  margin-top: 12px;
}

.jobs-ul {
  display: flex;
  flex-direction: column;
  margin-top: 10px;

  .jobs-li {
    align-items: center;
    display: flex;
    justify-content: space-between;
    min-height: 36px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);
    cursor: pointer;
    padding: 8px 12px;
    text-align: left;

    &:hover {
      background: #f0f0f0;
    }

    &:last-child {
      border-bottom: none;
    }
  }
}

.notify {
  background: #f0f0f0;
  color: #888;
  font-size: 13px;
  padding: 8px 4px;
  border-radius: 4px;
}


.fa-edit {
  color: #000;
}

.checkbox-list {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 12px;

  i {
    margin-right: 10px;
  }

  span {
    text-align: left;
    font-size: 14px;
    margin-left: 8px;
  }
}

.jobs-list {
  padding-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Files/Index.vue